'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var reactImask = require('react-imask');
var FontIcon = require('./FontIcon.js');
var react = require('@linaria/react');
var jsxRuntime = require('react/jsx-runtime');
require('prop-types');
require('deepmerge');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);

var _exp = function _exp() {
  return function (_ref) {
    var placeholder = _ref.placeholder;
    return placeholder ? 'none' : 'block';
  };
};
var _exp4 = function _exp4() {
  return function (_ref2) {
    var hasError = _ref2.hasError;
    return hasError ? 'var(--color-status-critical-lightest)' : 'var(--color-secondary-input-lightest)';
  };
};
var _exp5 = function _exp5() {
  return function (_ref3) {
    var hasError = _ref3.hasError;
    return hasError ? 'var(--color-status-critical-lighter)' : 'var(--color-secondary-input-lighter)';
  };
};
var _exp6 = function _exp6() {
  return function (_ref4) {
    var minWidth = _ref4.minWidth;
    return minWidth || '70px';
  };
};
var _exp7 = function _exp7() {
  return function (_ref5) {
    var maxWidth = _ref5.maxWidth;
    return maxWidth || '100%';
  };
};
var _exp8 = function _exp8() {
  return function (_ref6) {
    var hasLabel = _ref6.hasLabel;
    return hasLabel ? 'var(--space-xy-medium-rem)' : 'var(--space-xy-xSmall-rem)';
  };
};
var _exp9 = function _exp9() {
  return function (_ref7) {
    var paddingRight = _ref7.paddingRight;
    return paddingRight || '0';
  };
};
var _exp10 = function _exp10() {
  return function (_ref8) {
    var hasError = _ref8.hasError;
    return hasError ? 'var(--color-status-critical-base)' : 'var(--color-secondary-input-base)';
  };
};
var StyledInputContainer = /*#__PURE__*/react.styled('div')({
  name: "StyledInputContainer",
  "class": "sjx913h",
  propsAsIs: false,
  vars: {
    "sjx913h-0": [_exp()],
    "sjx913h-1": [_exp4()],
    "sjx913h-2": [_exp5()],
    "sjx913h-3": [_exp6()],
    "sjx913h-4": [_exp7()],
    "sjx913h-5": [_exp8()],
    "sjx913h-6": [_exp9()],
    "sjx913h-7": [_exp10()]
  }
});

var _excluded = ["autoComplete", "hasError", "helperText", "name", "label", "value", "minWidth", "maxWidth", "required", "className", "onChange", "onClick", "onFocus", "disabled", "type", "mask", "placeholder", "labelProps"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var TextInput = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$autoComplete = _ref.autoComplete,
    autoComplete = _ref$autoComplete === void 0 ? 'off' : _ref$autoComplete,
    _ref$hasError = _ref.hasError,
    hasError = _ref$hasError === void 0 ? false : _ref$hasError,
    helperText = _ref.helperText,
    name = _ref.name,
    label = _ref.label,
    value = _ref.value,
    minWidth = _ref.minWidth,
    maxWidth = _ref.maxWidth,
    required = _ref.required,
    className = _ref.className,
    onChange = _ref.onChange,
    onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    disabled = _ref.disabled,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    _ref$mask = _ref.mask,
    mask = _ref$mask === void 0 ? undefined : _ref$mask,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
    labelProps = _ref.labelProps,
    props = _objectWithoutProperties__default["default"](_ref, _excluded);
  var _useState = React.useState(type),
    _useState2 = _slicedToArray__default["default"](_useState, 2),
    currentType = _useState2[0],
    setCurrentType = _useState2[1];
  return /*#__PURE__*/jsxRuntime.jsxs(StyledInputContainer, {
    hasError: hasError,
    minWidth: minWidth,
    maxWidth: maxWidth,
    hasLabel: !!label,
    placeholder: placeholder,
    className: className,
    paddingRight: type === 'password' ? '2.5rem' : '0',
    children: [mask ? /*#__PURE__*/jsxRuntime.jsx(reactImask.IMaskInput, _objectSpread(_objectSpread({
      id: name,
      type: currentType,
      name: name,
      value: value,
      onChange: undefined,
      autoComplete: autoComplete,
      "data-testid": "textInput",
      placeholder: placeholder,
      disabled: disabled,
      ref: ref
    }, mask), {}, {
      mask: mask.mask,
      required: required,
      lazy: !value || mask.lazy,
      onAccept: function onAccept(value) {
        onChange === null || onChange === void 0 ? void 0 : onChange({
          target: {
            value: value
          }
        });
      },
      onFocus: onFocus,
      onClick: onClick
    }, props)) : /*#__PURE__*/jsxRuntime.jsx("input", _objectSpread({
      id: name,
      type: currentType,
      name: name,
      value: value || '',
      required: required || false,
      onChange: onChange,
      onClick: onClick,
      onFocus: onFocus,
      autoComplete: autoComplete,
      "data-testid": "textInput",
      placeholder: placeholder,
      disabled: disabled,
      ref: ref
    }, props)), type === 'password' && /*#__PURE__*/jsxRuntime.jsx("button", {
      onClick: function onClick() {
        return setCurrentType(currentType === 'password' ? 'text' : 'password');
      },
      className: "passwordButton",
      children: /*#__PURE__*/jsxRuntime.jsx(FontIcon["default"], {
        iconName: "".concat(currentType === 'password' ? 'eye-show' : 'eye-hide')
      })
    }), label && /*#__PURE__*/jsxRuntime.jsxs("label", _objectSpread(_objectSpread({
      htmlFor: name,
      className: value && 'filled' || ''
    }, labelProps), {}, {
      children: [label, required && /*#__PURE__*/jsxRuntime.jsx("span", {
        className: "red",
        children: "*"
      })]
    })), helperText && /*#__PURE__*/jsxRuntime.jsx("div", {
      className: hasError || required ? 'help' : 'info',
      children: helperText
    })]
  });
});

exports["default"] = TextInput;
